import React from "react";
import PropTypes from "prop-types";

const CardShortContent = ({ children = null, className = "", ...rest }) => {
  return <div className={`card__content ${className}`}>{children}</div>;
};

CardShortContent.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  className: PropTypes.string
};

export default CardShortContent;
